module.exports = __webpack_public_path__ + "img/upSTAT.acf31030.gif";